import domReady from '@wordpress/dom-ready';

domReady(function () {
  const toggleBtn = document.querySelector('.date-event-dropdown__toggle');
  const datepicker = document.querySelector(
    '.date-event-dropdown .findstr-field-datepicker'
  );

  if (toggleBtn && datepicker) {
    toggleBtn.addEventListener('click', function (e) {
      e.stopPropagation();

      const expanded = toggleBtn.getAttribute('aria-expanded') === 'true';
      toggleBtn.setAttribute('aria-expanded', String(!expanded));
      toggleBtn.classList.toggle('is-open', !expanded);
      datepicker.classList.toggle('is-open', !expanded);
    });

    // Close the dropdown if clicked outside
    document.addEventListener('click', function (e) {
      if (!datepicker.contains(e.target) && !toggleBtn.contains(e.target)) {
        toggleBtn.classList.remove('is-open');
        datepicker.classList.remove('is-open');
        toggleBtn.setAttribute('aria-expanded', 'false');
      }
    });
  }

  const select = document.querySelector('.wc-datepicker__month-select');
  if (select) {
    const comma = document.createElement('span');
    comma.textContent = ',';
    select.insertAdjacentElement('afterend', comma);
  }
});
